/**
 * @file index.tsx
 *
 * @fileoverview Renders a Multi column with different blocks on the page.
 */

import React from 'react';
import { MultiColImageTextParagraph } from '~/jobiqo/types/types';
import LazyHydrate from 'react-lazy-hydration';
import dynamic from 'next/dynamic';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { MultiColumn } from '~/vcl/organisms/04-landingpage/06-multi-column';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import Box from '~/vcl/atoms/07-box';

const Column = dynamic(() => import('~/jobiqo/components/Landingpage/Column'));

export interface MultiColImageTextProps {
  rowImageText: MultiColImageTextParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const MultiColImageText = ({
  rowImageText,
  maxContainerSize,
}: MultiColImageTextProps) => {
  return rowImageText.multiColItems ? (
    <LazyHydrate whenIdle={true}>
      <Box
        boxShadow="none"
        borderRadius="0px"
        paddingTop={6}
        paddingBottom={6}
        paddingLeft={[6, 8, 12]}
        paddingRight={[6, 8, 12]}
        marginTop={0}
        backgroundColorOverride={
          rowImageText.background
            ? `var(--color-${rowImageText.background})`
            : `transparent`
        }
      >
        <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
          <Spacing size="large" />
          <MultiColumn
            introTitle={
              <>
                <Text
                  tag="h2"
                  fontSize={[5, 6]}
                  marginTop={0}
                  lineHeight={[5, 6]}
                >
                  {rowImageText.multiColIntroTitle}
                </Text>
                <Spacing />
              </>
            }
            introText={
              <WYSIWYGText
                format="full_html"
                content={
                  rowImageText.multiColIntroText
                    ? rowImageText.multiColIntroText
                    : ''
                }
              />
            }
            items={rowImageText.multiColItems.map(
              (colItem, index) =>
                colItem && <Column key={index} column={colItem} />,
            )}
          />
          <Spacing size="large" />
        </Main>
      </Box>
    </LazyHydrate>
  ) : null;
};
export default MultiColImageText;
